export function navigateToResource(target: string) {
  if (!target) return;

  const pillStep = document.getElementById(target);
  if (!pillStep) return;

  pillStep.click();
}
